import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const OrderRequest = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="breadcrumb-area order request-with-selected-offer-bred">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-12">
              <div className="breadcrumb-content">
                <h3>Order Request</h3>
                <p>
                  Hendrerit porttitor ornare platea ante amet arcu at nunc.
                  Suscipit feugiat sagittis, id duis faucibus sit ultrices.
                  Netus sem diam turpis sollicitudin blandit massa ornare
                  facilisi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="request-order-area request-with-selected-offer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-10 offset-xl-1 col-12">
              <div className="account-box">
                <div className="account-form">
                  <form action="#">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Selected Package *</label>
                          <select id="disable-nice-select">
                            <option value="1" selected="selected">
                              Standard Plan
                            </option>
                            <option value="2" disabled>
                              Dropdown Stye Two
                            </option>
                            <option value="3" disabled>
                              Dropdown Stye Three
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Selected Users *</label>
                          <select id="disable-nice-select2" disabled>
                            <option value="1" selected="selected">
                              301-500 User (৳2500 /per month)
                            </option>
                            <option value="2" disabled>
                              Dropdown Stye Two
                            </option>
                            <option value="3" disabled>
                              Dropdown Stye Two
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Full name *</label>
                          <input
                            type="text"
                            name="Name"
                            placeholder="ex: Jhon Doe"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Email Address *</label>
                          <input
                            type="Email"
                            name="Email"
                            placeholder="ex: yourmail@mail.com"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>ISP Business Name *</label>
                          <input
                            type="text"
                            name="Name"
                            placeholder="Business name here"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Business Website</label>
                          <input
                            type="text"
                            name="website"
                            placeholder="https://"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Phone Number *</label>
                          <input
                            type="text"
                            name="number"
                            placeholder="+880"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Office Address *</label>
                          <input
                            type="text"
                            name="Address"
                            placeholder="Address here"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>District *</label>
                          <div className="select-add-icon">
                            <select>
                              <option value="1" selected="selected">
                                Dhaka
                              </option>
                              <option value="2">Chittagong</option>
                              <option value="3">Khulna</option>
                            </select>
                            <i className="fi fi-br-angle-down"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Country *</label>
                          <div className="select-add-icon">
                            <select>
                              <option value="1" selected="selected">
                                Bangladesh
                              </option>
                              <option value="2">United State</option>
                              <option value="3">Australia</option>
                            </select>
                            <i className="fi fi-br-angle-down"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Skype/ Telegram/ WhatsApp id *</label>
                          <input
                            type="text"
                            name="number"
                            placeholder="Id here"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <label>Remarks</label>
                          <input
                            type="text"
                            name="number"
                            placeholder="Any query?"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="offer-like-enroll">
                          <div className="course-description-main offer-like-enroll-main">
                            <div className="offer-like-enroll-head">
                              <p className="offer-like-enroll-title">
                                We offer a free course? Would you like to
                                enroll?
                              </p>
                              {/* <!-- Offer Like Enroll Tab Menu --> */}
                              <div className="addons-single__tabs">
                                <ul
                                  className="list-group"
                                  id="list-tab"
                                  role="tablist"
                                >
                                  <li>
                                    <a
                                      className="list-group-item active"
                                      data-bs-toggle="list"
                                      href="#yes"
                                      role="tab"
                                    >
                                      Yes
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="list-group-item"
                                      data-bs-toggle="list"
                                      href="#no"
                                      role="tab"
                                    >
                                      No
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              className="tab-content main-enroll-content"
                              id="nav-tabContent"
                            >
                              {/* <!-- Course Tab One --> */}
                              <div
                                className="tab-pane fade show active"
                                id="yes"
                                role="tabpanel"
                              >
                                <div className="form-group">
                                  <label>Select course *</label>
                                  <div className="select-add-icon">
                                    <select>
                                      <option value="1" selected="selected">
                                        Microtick Free Course by Atova
                                      </option>
                                      <option value="2">
                                        Dropdown Style One
                                      </option>
                                      <option value="3">
                                        Dropdown Style Two
                                      </option>
                                    </select>
                                    <i className="fi fi-br-angle-down"></i>
                                  </div>
                                  <p className="offer-like-enroll-link">
                                    [Learn more about the course. See the{" "}
                                    <Link to="/offerpage">Offer page</Link>]
                                  </p>
                                </div>
                              </div>
                              {/* <!-- Course Tab Two --> */}
                              <div
                                className="tab-pane fade"
                                id="no"
                                role="tabpanel"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 offset-lg-6 col-12">
                        <div className="agree-content form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="flexCheckDefault"
                          />
                          <label
                            className="form-check-label"
                            for="flexCheckDefault"
                          >
                            <p>
                              I have read and agree to the{" "}
                              <Link to="/termscondition">
                                Terms & Condition
                              </Link>{" "}
                              and{" "}
                              <Link to="/privacypolicy">Privacy Policy</Link>
                            </p>
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6 offset-lg-6 col-md-6 col-12">
                        <div className="account-button">
                          <button type="submit" className="theme-btn primary">
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderRequest;
